const baseStyle = {
  content: {
    borderWidth: "1px",
    boxShadow: "lg",
    borderRadius: "lg",
    background: "bg.surface",
    overflow: "hidden"
  }
};
const popover = {
  baseStyle
};

export { popover as default };
